<template>
    <div class="loader-nav">
        <div class="logo-action-container">
            <img
                src="../assets/images/logo-background.png"
                class="logo-background"
                alt=""
            >
            <img
                src="../assets/images/logo-icon.png"
                class="logo-icon"
                alt=""
            >
            <div class="animation-div" />
            <div class="animation-div second" />
        </div>
        <img
            src="../assets/images/logo-text.png"
            class="logo-text"
            alt=""
        >
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss" scoped>
    .loader-nav {
        display: flex;
        align-items: center;
        flex-direction: column;
        background-color: white;
        position: fixed;
        width: 100%;
        height: 100vh;
        z-index: 99999;

        .content {
            @include center-children;
            flex-direction: column;
            width: 100%;

            .percentage {
                font-size: 20px;
                font-weight: bold;
                letter-spacing: 0.8px;
            }

            .logo-icon {
                width: 30%;
            }

            .progress-nav {
                margin-top: 50px;
                width: 100%;
                position: relative;
                height: 4px;

                .animated-line {
                    height: 100%;
                    background-color: #5265e8;
                }
            }
        }

        .logo-action-container {
            margin-top: 18vh;
            position: relative;

            .logo-background {
                width: 220px;
            }

            .logo-icon {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                @include mq(max-width 1025px) {
                    width: 65%;
                }
            }

            .animation-div {
                @include circle(100%);
                background-color: #7e8cee;
                position: absolute;
                left: 0;
                top: 0;
                animation: wave 1.5s cubic-bezier(0.58, 0.65, 0.48, 0.53) infinite;
                z-index: -1;

                &.second {
                    animation: wave 1.5s .5s cubic-bezier(0.58, 0.65, 0.48, 0.53) infinite;
                }
            }
        }

        .logo-text {
            margin-top: 8vh;
            @include mq(max-width 1025px) {
                width: 65%;
            }
        }

        @keyframes wave {
            50% {
                transform: scale(1.3);
                opacity: .5;
            }
            100% {
                transform: scale(1.6);
                opacity: 0;
            }
        }
    }
</style>
